import React, { useState } from 'react';
import ContactModal from './ContactModal';
import '../styles/Footer.css';

function Footer() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleContactClick = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">🛡 Network Slayer</div>
        <div className="email">noreply@network-slayer.com</div>
        <p>&copy; {new Date().getFullYear()} All rights reserved.</p>
        <div className="footer-links">
          <a href="https://www.linkedin.com/" target="_blank" rel="noreferrer">LinkedIn</a>
          <a href="https://github.com/" target="_blank" rel="noreferrer">GitHub</a>
          <button type="button" className="contact-link" onClick={handleContactClick}>Contact</button>
        </div>
      </div>
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </footer>
  );
}

export default Footer;
